// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"45":"24e510d1","60":"24cca860","115":"0f3b8ec8","171":"5837efde","509":"09477eb8","770":"a83f403f","865":"4eb33a18"}[chunkId] + ".css";
};